LatinLetters 		= new Array("A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "I", "Y",
								"a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "i", "y");
var GreekLetters	= new Array("Α", "Β", "Ψ", "Δ", "Ε", "Φ", "Γ", "Η", "Ι", "Ξ", "Κ", "Λ", "Μ", "Ν", "Ο", "Π", "",  "Ρ", "Σ", "Τ", "Θ", "Ω", "ς", "Χ", "Υ", "Ζ", "Ϊ", "Ϋ",
								"α", "β", "ψ", "δ", "ε", "φ", "γ", "η", "ι", "ξ", "κ", "λ", "μ", "ν", "ο", "π", "",  "ρ", "σ", "τ", "θ", "ω", "ς", "χ", "υ", "ζ", "ϊ", "ϋ");
var GreekAccentLetters		= new Array("Ά", "Έ", "Ή", "Ί", "Ό", "Ώ", "Ύ",
										"ά", "έ", "ή", "ί", "ό", "ώ", "ύ");
var GreekNoAccentLetters 	= new Array("Α", "Ε", "Η", "Ι", "Ο", "Ω", "Υ",
									 	"α", "ε", "η", "ι", "ο", "ω", "υ");
var InvalidGreekLetters = new Array("Γ", "Δ", "Θ", "Λ", "Ξ", "Π", "Σ", "Φ", "Ψ", "Ω", "ς", "Ϊ", "Ϋ");
var Digits = new Array("0","1","2","3","4","5","6","7","8","9");
var SpecialCharacters = new Array("~","!","@","#","$","%","^","&","*","(",")","_","+","-","=",".",",");
var CouponCodeSpecial = new Array(":","\/","-");
function initAddressChars(){
	/*$('form[name="address-form"] .replace-chars').each(function(){
		
	});*/
}
function toDigit(val){
	if(val==null || val.length!=1 || jQuery.inArray(val,Digits) == -1){
		return "";
	}
	return val;
}
function toSpecial(val){
	if(val==null || val.length!=1 || jQuery.inArray(val,SpecialCharacters)==-1){
		return "";
	}
	return val;
}

function toDecimal(local, val) {
	if (val==null || (val!=getDecimalSeparator(local) && jQuery.inArray(val,Digits)==-1)) {
		return "";
	}
	return val;
}
function toGreek(val) {
	if (val == null || val.length != 1) {
		return "";
	}
	if (jQuery.inArray(val,GreekLetters) != -1 || jQuery.inArray(val,GreekAccentLetters) != -1 ) {
		return val;
	}
	var index = jQuery.inArray(val,LatinLetters);
	if (index != -1) {
		var result = GreekLetters[index];
		return result;
	}
	return "";
}
function toGreekNoAccent(val) {
	if (val == null || val.length != 1) {
		return "";
	}
	var index = jQuery.inArray(val,GreekAccentLetters);
	if (index != -1) {
		if (index != -1) {
			var result = GreekNoAccentLetters[index];
			return result;
		}
	}
	return val;
}
function toLatin(val) {
	if (val == null || val.length != 1) {
		return "";
	}
	if (jQuery.inArray(val,LatinLetters) != -1) {
		return val;
	}
	var index = jQuery.inArray(val,GreekLetters);
	if (index != -1) {
		var result = LatinLetters[index];
		return result;
	}
	return "";
}
function toCouponCode(val){
	if (val==null || val.length==0) {
		return "";
	}
	var i;
	var result = "";
	if (jQuery.inArray(val,CouponCodeSpecial) != -1) {
		return val;
	}
	result=toDigit(val)
	if (result!="") {
		return result;
	}
	result=toLatin(val) 
	if (result!="") {
		return result;
	}
	return result;
}
function toGreekValue(val,digitAllowed,specialAllowed,spaceAllowed) {
	var result = "";
	if (val == null || val.length == 0) {
		return result;
	}
	var i;
	var curLetter;
	var newLetter;
	for (i = 0; i < val.length; i++) {
		curLetter = val.charAt(i);
		newLetter = toGreek(curLetter);
		if(newLetter=="" && digitAllowed){
			newLetter=toDigit(curLetter);
		}
		if(newLetter=="" && specialAllowed){
			newLetter=toSpecial(curLetter);
		}
		if(newLetter=="" && spaceAllowed && curLetter==" "){
			newLetter=" ";
		}
		result += newLetter;
	}
	return result;
}
function toGreekNoAccentValue(val) {
	var result = "";
	if (val == null || val.length == 0) {
		return result;
	}
	var i;
	var curLetter;
	var newLetter;
	for (i = 0; i < val.length; i++) {
		curLetter = val.charAt(i);
		newLetter = toGreekNoAccent(curLetter);
		result += newLetter;
	}
	return result;
}
function toLatinValue(val,digitAllowed,specialAllowed,spaceAllowed) {
	var result = "";
	if (val == null || val.length == 0) {
		return result;
	}
	var i;
	var curLetter;
	var newLetter;
	for (i = 0; i < val.length; i++) {
		curLetter = val.charAt(i);
		newLetter = toLatin(curLetter);
		if(newLetter=="" && digitAllowed){
			newLetter=toDigit(curLetter);
		}
		if(newLetter=="" && specialAllowed){
			newLetter=toSpecial(curLetter);
		}
		if(newLetter=="" && spaceAllowed && curLetter==" "){
			newLetter=" ";
		}
		result += newLetter;
	}
	return result;
}
function toDigitValue(val){
	if(val==null || val.length==0){
		return "";
	}
	var i;
	var result = "";
	for(i=0;i<val.length;i++){
		result += toDigit(val.charAt(i));
	}
	return result;
}
function toDecimalValue(local, val) {
	if (val==null || val.length==0) {
		return "";
	}
	var result="";
	for(i=0;i<val.length;i++){
		result += toDecimal(local, val.charAt(i));
	}
	return result;
}
function toValidPlateLetters(val) {
	if (val == null || val.length == 0 ) {
		return "";
	}
	var greekVal = toGreekValue(val,false,false,false);
	var result = "";
	var i;
	var l;
	for (i = 0; i < greekVal.length; i++) {
		l = greekVal.charAt(i).toUpperCase();
		if (jQuery.inArray(l,InvalidGreekLetters) == -1) {
			result += l;
		}
	}
	return toCapital(result);
}
function toValidPlateNumbers(val) {
	if (val == null || val.length == 0 ) {
		return "";
	}
	var result = toDigitValue(val);
	if(result==null||result.length==0){
		return "";
	}
	return removeLeadingZero(result);
}
function removeLeadingZero(val){
	if(val==null||val.length==0){
		return "";
	}
	if(val.charAt(0)=='0'){
		return removeLeadingZero(val.substring(1));
	}
	return val;
}
function removeLeadingDecimalSeparatorAndZeroes(local, val){
	if(val==null||val.length==0){
		return "";
	}
	if(val.charAt(0)==getDecimalSeparator(local) || val.charAt(0)=='0'){
		return removeLeadingDecimalSeparatorAndZeroes(local, val.substring(1));
	}
	return val;
}
function addThousandsSeparator(local, val){
	if(val==null||val.length==0){
		return "";
	}
	return $.formatNumber(val, {format:"#,###", locale:local});
}

function setExactDecimalDigitsNumVal(local, inVal, decimalDigitsNum) {
	// val = jQuery(inVal).val();
	var decimalSeparator = getDecimalSeparator(local);
	if (inVal == null || inVal.length == 0) {
		return;
	}
	var commaPos = inVal.lastIndexOf(decimalSeparator);
	if (commaPos < 0) {
		inVal += decimalSeparator;
		for ( var i = 0; i < decimalDigitsNum; i++) {
			inVal += '0';
		}
	} 
	else {
		var decimalDigits = inVal.length - commaPos - 1;
		var decimalDigitsDiff = decimalDigitsNum - decimalDigits;
		if (decimalDigitsDiff > 0) {
			for ( var i = 0; i < decimalDigitsDiff; i++) {
				inVal += '0';
			}
		} 
		else if (decimalDigitsDiff < 0) {
			for (var i = 0; i > decimalDigitsDiff; i--) {
				inVal = inVal.substring(0, inVal.length - 1);
			}
		}
	}
	return inVal;
}

function setExactDecimalDigitsNumAndEndChar (local, inVal, decimalDigitsNum, end) {
	val = jQuery(inVal).val();
	if(val==null || val.length == 0){
		return "";
	}
	val = setExactDecimalDigitsNumVal(local, val, decimalDigitsNum);
	if (end!=null) {
		val += end;
	}
	jQuery(inVal).val(val);
}

function setExactDecimalDigitsWithMin (local, inVal, decimalDigitsNum, min) {
	var oldValue = jQuery(inVal).val();
	var newValue = oldValue;
	if(oldValue==null || oldValue.length == 0){
		newValue = "";
	}
	else if (oldValue < min) {
		newValue = "";
	}
	else {
		newValue = setExactDecimalDigitsNumVal(local, oldValue, decimalDigitsNum);
	}
	assignValue(inVal, oldValue, newValue)
}

function toCapital(val){
	if(val==null || val.length == 0){
		return "";
	}
	var result = val;
	if(val.indexOf('ς') != -1){
		var i;
		result = "";
		for(i=0;i<val.length;i++){
			var t = val.charAt(i);
			if(t == 'ς'){
				t = "Σ";
			}
			result+=t;
		}
	}
	return result.toUpperCase();
}
function toLower(val){
	if(val==null || val.length == 0){
		return "";
	}
	var result = val;
	return result.toLowerCase();
}
function toLowerGreek(val){
	if(val==null || val.length == 0){
		return "";
	}
	var result = val.toLowerCase();	
	
	if (result.charAt(result.length-1)=='σ') {
		result = result.replace(/ς/g, 'σ');
		result = result.replace(/σ /g, 'ς ');
		return result.substring(0, result.length-1).concat('ς');
	}
	result = result.replace(/ς/g, 'σ');
	result = result.replace(/σ /g, 'ς ');
	return result;
}
function toGreekIdValue(val) {
	if(val==null || val.length == 0){
		return "";
	}
	var result="";
	var tmp="";
	// set first char as letter
	var i;
	for (i=0; i < val.length; i++) {
		tmp=toGreek(val[i]);
		if (tmp!="") {
			result=tmp;
			i++;
			break;
		}
	} 
	// set second char as letter or number
	for (; i < val.length; i++) {
		tmp=toGreekValue(val[i], true, false, false);
		if (tmp!="") {
			result+=tmp;
			i++;
			break;
		}
	}
	
	// set next chars as numbers
	for (; i < val.length; i++) {
		result+=toDigit(val[i]);
	}
	return result;
}
function closeAll() {
	jQuery("button[rel]").each( function() {
		jQuery(this).overlay().close();
	});
}
function greek(obj,digit,special,space){
	var oldValue = jQuery(obj).val();
	var newValue = toGreekValue(oldValue,digit,special,space);
	assignValue(obj,oldValue,newValue);
}
function latin(obj,digit,special,space){
	var oldValue = jQuery(obj).val();
	var newValue = toLatinValue(oldValue,digit,special,space);
	assignValue(obj,oldValue,newValue);
}
function noAccent(obj) {
	var oldValue = jQuery(obj).val();
	var newValue = toGreekNoAccentValue(oldValue);
	assignValue(obj,oldValue,newValue);
}
function validPlateLetters(obj){
	var oldValue = jQuery(obj).val();
	var newValue = toValidPlateLetters(oldValue);
	var newValue = toGreekNoAccentValue(newValue);
	assignValue(obj,oldValue,newValue);
}
function validPlateNumbers(obj){
	var oldValue = jQuery(obj).val();
	var newValue = toValidPlateNumbers(oldValue);
	assignValue(obj,oldValue,newValue);
}
function capitalize(obj){
	var oldValue = jQuery(obj).val();
	var newValue = toCapital(oldValue);
	assignValue(obj,oldValue,newValue);
}
function firstCapital(obj){
	var oldValue = jQuery(obj).val();
	var newValue = toCapital(oldValue.substring(0,1)) + toLowerGreek(oldValue.substring(1));
	assignValue(obj,oldValue,newValue);
}
function lowercase(obj){
	var oldValue = jQuery(obj).val();
	var newValue = toLower(oldValue);
	assignValue(obj,oldValue,newValue);
}
function digits(obj){
	var oldValue = jQuery(obj).val();
	var newValue = toDigitValue(oldValue);
	assignValue(obj,oldValue,newValue);
}
function digitsWithoutZeroAtStart(obj){
	var oldValue = jQuery(obj).val();
	var newValue = removeLeadingZero(toDigitValue(oldValue));
	assignValue(obj,oldValue,newValue);
	
}
function digitsWithSeparatorWithoutZeroAtStart(local, obj){
	var oldValue = jQuery(obj).val();
	var middleValue = removeLeadingZero(toDigitValue(oldValue));
	var newValue = addThousandsSeparator(local, middleValue);
	assignValue(obj,oldValue,newValue);
	
}
function digitsWithSeparatorWithoutZeroAtStartWithMin(local, obj, min){
	var oldValue = jQuery(obj).val();
	var middleValue = oldValue;
	middleValue = removeLeadingDecimalSeparatorAndZeroes(local, toDecimalValue(local, middleValue));
	if (middleValue < min) {
		middleValue = 0;
	}
	assignValue(obj,oldValue,middleValue);
	digitsWithSeparatorWithoutZeroAtStart(local, obj);
}
function greekId(obj) {
	var oldValue = jQuery(obj).val();
	var newValue = toGreekIdValue(oldValue);
	assignValue(obj,oldValue,newValue);
}
function greekCapitalNoAccent(obj) {
	var oldValue = jQuery(obj).val();
	var newValue = toGreekValue(oldValue,false,false,true);
	newValue = toCapital(newValue);
	newValue = toGreekNoAccentValue(newValue);
	assignValue(obj,oldValue,newValue);
}
function digitsWithDecSepWithoutZeroOrDecSepAtStart(local, obj, max){
	var decimalSep = getDecimalSeparator(local);
	var oldValue = jQuery(obj).val();
	var newValue = oldValue;
	var first=oldValue.indexOf(decimalSep);
	var last=oldValue.lastIndexOf(decimalSep);
	while (last != first) {
		newValue = newValue.substring(0, last);
		last=newValue.lastIndexOf(decimalSep);
	}
	newValue = removeLeadingDecimalSeparatorAndZeroes(local, toDecimalValue(local, newValue));
	if(newValue.length > 0) {
		var floatValue = parseFloat(newValue.replace(decimalSep, "."));
		if (max!=null) {
			while(floatValue > max) {
				newValue = newValue.substring(0, newValue.length-1);
				if(endsWith(newValue, decimalSep)) {
					newValue = newValue.substring(0, newValue.length-1);
				}
				if(newValue.length <= 0) {
					break;
				}
				floatValue = parseFloat(newValue.replace(decimalSep, "."));
			}
		}
	}
	assignValue(obj,oldValue,newValue);
}
function greekOrLatin(obj,digitAllowed,specialAllowed,spaceAllowed){
	var oldValue = jQuery(obj).val();
	if(oldValue==null || oldValue.length==0){
		return;
	}
	var greekOcc = countOccurences(oldValue, GreekLetters);
	var latinOcc = countOccurences(oldValue, LatinLetters);
	var newValue;
	if(greekOcc>latinOcc){
		newValue = toGreekValue(oldValue, digitAllowed, specialAllowed, spaceAllowed);
	} else {
		newValue = toLatinValue(oldValue, digitAllowed, specialAllowed, spaceAllowed);
	}
	assignValue(obj,oldValue,newValue);
}
function signedDigits(obj){
	var oldValue = jQuery(obj).val();
	if(oldValue==null || oldValue.length==0){
		return;
	}
	var result = "";
	var val = jQuery(obj).val();
	if (val == null || val.length == 0) {
		return result;
	}
	var i;
	var curLetter;
	var newLetter;
	for (i = 0; i < val.length; i++) {
		curLetter = val.charAt(i);
		newLetter = toDigit(curLetter);
		if(newLetter=="" && curLetter=="-"){
			newLetter="-";
		}
		result += newLetter;
	}
	assignValue(obj,oldValue,result);
}

function countOccurences(val,array){
	if(val==null||val.length==0){
		return 0;
	}
	var count = 0;
	var i;
	for(i=0;i<val.length;i++){
		if(jQuery.inArray(val.charAt(i),array) != -1){
			count++;
		}
	}
	return count;
}
function onLoadFunction(){
}
function toPhone(obj,startChar,maxChars){
	var oldValue = jQuery(obj).val();
	var newValue = startWith(toDigitValue(oldValue),startChar);
	newValue = getMaxChars(newValue,maxChars);
	assignValue(obj,oldValue,newValue);
}

function toMobile(obj,startChar,secondChar,maxChars){
	var oldValue = jQuery(obj).val();
	var firstValue = startWith(toDigitValue(oldValue),startChar);
	var newValue = secondCharIs(firstValue,secondChar);
	newValue = getMaxChars(newValue,maxChars);
	assignValue(obj,oldValue,newValue);
}
function toCouponCodeValue(event, obj){
	// if alt, shif or ctrl key pressed, ignore action
	if (event.keyCode >= 16 && event.keyCode <= 18) {
		return;
	}
	var oldValue = val = jQuery(obj).val();
	if(oldValue==null || oldValue.length==0){
		return;
	}
	
	var curLetter, newLetter, tmpLetter
		result="";

	for (var i=0; i < oldValue.length; i++) {
		curLetter = val.charAt(i);
		tmpLetter = toCapital(curLetter);
		newLetter = toCouponCode(tmpLetter);
		result += newLetter;
	}
	assignValue(obj,oldValue,result);
}
function startWith(val,char){
	if(val==null||val.length==0){
		return "";
	}
	if(val.charAt(0)!=char){
		return removeLeadingZero(val.substring(1));
	}
	return val;
}
function secondCharIs(val,char) {
	if(val==null||val.length==0){
		return "";
	}
	if(val.length<2) {
		return val;
	}
	if(val.charAt(1)!=char){
		return removeLeadingZero(val.charAt(0)+val.substring(2));
	}
	return val;
}
function getMaxChars(val,maxChars) {
	if (val==null || val.length==0){
		return "";
	}
	if (val.length>maxChars) {
		return val.substr(0,maxChars);
	}
	return val;
}
function moveToNext(obj,charNo,event){
	if(event.which==9 || event.which==16 || event.which==37 || event.which==38 || event.which==39 || event.which==40){
		event.preventDefault();
		return false;
	}
	jQuery(document).ready(function(){
		if(jQuery(obj).val()!= null && jQuery(obj).val().length == charNo){
			var nextObj = jQuery(obj).next();
			while(!(nextObj.is('input'))){
				nextObj = nextObj.next();
				if(nextObj==null){
					break;
				}
			}
			if(nextObj!=null){
				nextObj.focus();
				nextObj.select();
			}
		}
	});
}
function endsWith(str, suffix) {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

onLoadFunction();

/**
 * @returns the decimal separator based on the locale used by lifreay
 */
function getDecimalSeparator(local) {
    var n = 1.1;
    n = $.formatNumber(n, {format:"0.0", locale:local}).substring(1, 2);
   return n;
}

/**
 * replace this tag with text from its relative attribute
 */
function replaceWithRel(tag) {
	tag.replaceWith(tag.attr('rel'));
}

function blockPageWithoutChange(){
	jQuery(document).ready(function(){
		jQuery.blockUI( {
			message : '',
			css : {
				border : '0px none',
				top : '0',
				left : '0',
				width : '100%',
				opacity : '0',
				cursor: 'auto'
			},
			overlayCSS : {
				backgroundColor : '#fff',
				opacity : '0',
				cursor: 'auto'
			}
		});
	});
}

function unBlockPageImmediately() {
	try {
		jQuery.unblockUI();
	} catch (err) {

	}
}

function moveContentsToEnd(elemId){
	jQuery(document).ready(function(){
		var current = jQuery('#'+elemId+':first');
		while (jQuery('#'+elemId).length) {
			jQuery('#'+elemId).remove();
		};
		jQuery('body').append(current);
	});
}

function showPanel(elemId){
	jQuery(document).ready(function(){
		if(jQuery('#'+elemId).find('ol.feedback-panel').length > 0){
			jQuery('#'+elemId).overlay({color:'#ccc',mask:{color:'#111',loadSpeed:100,opacity:0.5},top:'center',left:'center',load:true});		
		} else if (jQuery('#'+elemId).find('ul.feedback-panel').length > 0) {
			jQuery('#'+elemId).overlay({color:'#ccc',mask:{color:'#111',loadSpeed:100,opacity:0.5},top:'center',left:'center',load:true});	
		}
	});
}

function disableAutocomplete(elementId) {
	jQuery('#'+elementId).attr('autocomplete','off');
}

function showErrorIcons() {
	$(".error-icon.show-error-icon").removeClass("show-error-icon");
	$(".error-icon + .component-error").prev().addClass("show-error-icon");
	$(".error-icon + .select-component-error").prev().addClass("show-error-icon");
}

function showErrorIconsAlt() {
	$(".component-error").closest('td').next('td').find('div.error-icon-2').addClass("show-error-icon");
}

function ddJscroll(elem){
	$('.drop-holder').jScrollPane({verticalDragMaxHeight:22,showArrows:true});
	$('.drop-list').width($('.select-options').width());
}

function assignValue(obj,oldValue,newValue){
	var t = jQuery(obj);
	if(oldValue!=newValue){
		t.val(newValue);
		if (jQuery.data(t.get(0), 'ischanged') && !jQuery.browser.mozilla) {
// console.log('assignValue if:' + jQuery.data(t.get(0), 'ischanged'));
			jQuery.data(t.get(0), 'ischanged', 'true');
// console.log('assignValue if:' + jQuery.data(t.get(0), 'ischanged'));
		}
	}
/**
	else if (jQuery.data(t.get(0), 'ischanged') && !jQuery.browser.mozilla) {
// console.log('assignValue else:' + jQuery.data(t.get(0), 'ischanged'));
		jQuery.data(t.get(0), 'ischanged', 'false');
// console.log('assignValue else:' + jQuery.data(t.get(0), 'ischanged'));
	}
*/	
}

/**
 * the following two functions detect change on chrome-ie when value is set
 * programaticaly. make sure that only one transformation functino exists for
 * the input.
 */
function focusChange(tobj) {
	var obj = jQuery(tobj).get(0);
// console.log('focus isChanged:' + jQuery.data(obj, 'ischanged'));
	jQuery.data(obj, 'ischanged', 'false');
// console.log('focus isChanged:' + jQuery.data(obj, 'ischanged'));
}
function blurChange(tobj) {
	var obj = jQuery(tobj).get(0);
// console.log('blur isChanged:' + jQuery.data(obj, 'ischanged'));
	if (jQuery.data(obj, 'ischanged')=='true' && !jQuery.browser.mozilla) {
		tobj.trigger('change');
	}
}

function redirectToUrl (divName, redirectUrl, salesChannel, quoteId, crmActivityId, crmCustomerId, ucmCustomerId) {
	if(divName == null || divName.length==0 || redirectUrl == null || redirectUrl.length==0){
		return;
	} 
	 var innerCode = '<form id="reviseCombi" method="get" action="';
		 
	 innerCode += redirectUrl;
	 innerCode += '">';
	 if (salesChannel != null) {
		 innerCode += createHiddenInput('sales-channel', salesChannel);
	 }
	 if (quoteId != null) {
		 innerCode += createHiddenInput('quote-id', quoteId);
	 }
	 if(crmActivityId != null) {
	 	innerCode += createHiddenInput('crm-activity-id', crmActivityId);
	 }
	 if(crmCustomerId != null) {
		 innerCode += createHiddenInput('crm-customer-id', crmCustomerId);
	 }
	 if(ucmCustomerId != null) {
		 innerCode += createHiddenInput('ucm-customer-id', ucmCustomerId);
	 }
	 innerCode += '</form>' 
	 var mydiv = document.getElementById(divName).innerHTML = innerCode;
	 f=document.getElementById('reviseCombi');
	 if(f){
		 f.submit();
	 }
}

function addProductLineAsClass(pd) {
	$(document.body).addClass(pd);
}

function createHiddenInput(name, value) {
	 var inputStart =  '<input name="';
	 var inputMiddle =  '" type="hidden" value="';
	 var inputEnd = '"/>';
	 return inputStart + name + inputMiddle + value + inputEnd;
}

/**
 * Hides the premium container if a value in a field is changed.
 * 
 * The form should have an attribute name="main-form", while the premiums
 * container should have a name="premium-cnt".
 */
function hideContainerOnInputChange(formName, containerToHideName) {
	jQuery('[name="' + formName + '"] :input:not(:input[type=radio], button)').bind('change keyup input', function() {
		$('[name="' + containerToHideName + '"]').hide();
	});
	jQuery('[name="' + formName + '"] :input[type=radio]').bind('click', function() {
		$('[name="' + containerToHideName + '"]').hide();
	});
}

/**
 * Hides the premium container if a value in a field is changed.
 * 
 * The form should have an attribute name="main-form", while the containers to
 * be hidden should have a name="premium-hide" attribute.
 */
function hidePremiumContainer() {
	jQuery('[name="main-form"] :input:not(:input[type=radio], button)').bind('change keyup', hide);
	jQuery('[name="main-form"] :input[type=radio]').bind('click', hide);
}

function hide() {
	$('[name="premium-cnt"]').empty();
	$('[name="premium-hide"]').empty();
}

jQuery.fn.extend({
    covers: function() {
          $=jQuery;
          $("#covers-table tbody tr:gt(1):odd td.cover-td").addClass("cover-td-alt");
          $("#covers-table tbody tr:gt(1):odd td.economic-cover-td").addClass("economic-cover-td-alt");
          $("#covers-table tbody tr:gt(1):odd td.value-cover-td").addClass("value-cover-td-alt");
          $("#covers-table tbody tr:gt(1):odd td.premium-cover-td").addClass("premium-cover-td-alt");
    },
	coversRow: function() {
		$=jQuery;
		$("#covers-table tbody tr:odd").addClass("plan-lst-alt");
	},
	executeInputsBlur: function() {
		$=jQuery;
		$(":input").focus();
		$(":input").blur();
	}
});

function colorCoversTable() {
	$=jQuery;
	$(".cover-tr:even").removeClass("cover-index-0").addClass("cover-index-1");
	var special = $(".premium-special").index() + 1;
	if (special) {
		$("tr.cover-tr td:nth-child("+special+")").removeClass("cover-tick-0").removeClass("cover-tick-1").addClass("cover-tick-s");
	}
}

/**
 * Scrolls to the top of an element.
 * If a second element is given, scrolling will continue, 
 * until the second element is displayed
 * 
 * @param selector 
 * 				the selector to scroll to
 * @param shownDiv
 * 				the div that must be displayed
 */
function scrollToPosition(selector, shownElementSelector) {
	var scrollPosition = ($(selector).offset().top - 20);
	if (shownElementSelector) {
		var shownElement = $(shownElementSelector);
	    var shownElemBottom = shownElement.offset().top + shownElement.height();
	    var differrence = shownElemBottom - scrollPosition;
		var viewportHeight = $(window).height();
		if (differrence > viewportHeight) {
			scrollPosition += differrence - viewportHeight;
		}
	}
	$('html, body').animate({scrollTop: scrollPosition}, 500);
}

function showAndScrollTo(selector) {
	jQuery(selector).show();
	scrollToPosition(selector, "");
}

function executeOdometer() {
	window.Odometer.init();
	if ($('.odometer').length) {
		setTimeout(function(){
			 $('.odometer').html(5000);
		}, 1000);
	};
}

function centerWicketModal() {
	$=jQuery;
	var myWindow = $('.wicket-modal');
	if (myWindow) {
		myWindow.css('display', 'block');
		myWindow.css('position', 'fixed');
		myWindow.css('top', Math.max(0, (($(window).height() - $(myWindow).outerHeight()) / 2)) + 'px');
		myWindow.css('left', Math.max(0, (($(window).width() - $(myWindow).outerWidth()) / 2)) + 'px');
	}
};

$(document).ready(function(){
	showErrorIcons();
});

wicketGlobalPostCallHandler = function() {
	$=jQuery;
	showErrorIcons();
	showErrorIconsAlt();
	jcf.customForms.replaceAll();
	$('.feedback-scrollable').jScrollPane({verticalDragMaxHeight:22,showArrows:true});
};

/**
 * Hides this panel and displays the previous or next depending on boolean next
 * 
 * @param obj
 *            the object being pressed
 * @param next
 *            true for next, false for previous
 */
function findHelp(obj, next) {
	var rel = obj.parent();
	rel.find("a.close").click();
	setTimeout(function() {
		var curTr = $('[rel="#'+ rel.attr('id') +'"]').parent();
		// next
		if (next) {
			var nextTd = curTr.nextAll('tr.cover-tr:first').find('.cover-name-td');
			// nextTd found
			if (nextTd.length) {
				nextTd.click();
				return;
			}
			// nextTd not found, move to first
			var curTbl = curTr.closest('table');
			var firstTr = curTbl.find("tr.cover-tr:first").find('.cover-name-td');
			firstTr.click();
			return;
		}
		// previous
		var prevTd = curTr.prevAll('tr.cover-tr:first').find('.cover-name-td');
		if (prevTd.length) {
			prevTd.click();
			return
		}
		// prevTd not found, move to last
		var curTbl = curTr.closest('table');
		var lastTr = curTbl.find("tr.cover-tr:last").find('.cover-name-td');
		lastTr.click();
	}, 250);
}

/**
 * This method defines the value of Anytime.abt object. The value includes an
 * executed experiment object, which holds the experiment name, and the executed
 * variation. The value is in JSON form.
 * 
 * @param experimentInJSON
 *            The defined experiment in JSON format
 */
function defineExecutedExperiments(experimentInJSON) {
	if(Anytime) {
		Anytime.abt = Anytime.abt || [];
		Anytime.abt.push(JSON.parse(experimentInJSON));
	}
}

jQuery(document).ready(function(){
	try {
		jQuery.unblockUI({ fadeOut : 500 });
	} 
	catch (err) {}
});